import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MessageIcon from "../../../icons/Message";
import {
  getCurrentUserSsoId,
  getThreadSelector,
} from "../../../../state/selectors/general.selectors";
import Btn from "../../../atoms/Btn";
import SourceEntity from "../../models/SourceEntity";
import threadService from "../../../../services/threadService";
import Topic from "../../../../models/Topic";
import { pluralize } from "../../../../common/helpers/helpers";

function CommentButton({
  sourceEntity,
  onSelect,
  isActive,
  topic,
  slug,
  isTab,
  size,
}) {
  const sb = sourceEntity.type;
  const msg = `Publication comments related to this ${sb}`;

  useEffect(() => {
    threadService.loadCommentStats(slug);
  }, [slug]);

  const mainCl = "tw-opacity-70 hover:tw-opacity-100";
  const inactiveCl = "tw-opacity-40";
  const nonLoadingClass = isActive ? "tw-text-blue-500" : mainCl;
  const colorClass = topic.isLoading && !isTab ? inactiveCl : nonLoadingClass;

  return (
    <div className={`tw-flex tw-items-center tw-relative ${colorClass}`}>
      <Btn
        onSubmit={onSelect}
        data-tooltip={msg}
        data-tooltip-delay={700}
        data-tooltip-class="publications-tooltip"
        className="tw-flex tw-items-center tw-gap-2"
      >
        <div className="tw-relative tw-transition-colors tw-duration-300">
          <MessageIcon size={size} className="tw-fill-current" />
        </div>
        {isTab ? (
          <div>
            {topic?.commentCount}{" "}
            {pluralize(topic?.commentCount, "comment", "comments")}
          </div>
        ) : (
          <div>{topic?.commentCount}</div>
        )}
      </Btn>
    </div>
  );
}

CommentButton.propTypes = {
  isActive: PropTypes.bool,
  topic: PropTypes.instanceOf(Topic),
  sourceEntity: PropTypes.instanceOf(SourceEntity),
  onSelect: PropTypes.func,
  isTab: PropTypes.bool,
  size: PropTypes.number,
  slug: PropTypes.string,
};

CommentButton.defaultProps = {
  onSelect: () => {},
  isActive: false,
  topic: new Topic({ slug: "", isLoading: true }),
  sourceEntity: null,
  slug: "",
  isTab: false,
  size: 14,
};

const mapStateToProps = (state, { slug }) => {
  return {
    ssoId: getCurrentUserSsoId(state),
    topic: getThreadSelector(state, slug),
    slug,
  };
};

export default React.memo(connect(mapStateToProps, {})(CommentButton));
